import React, { useState } from "react";
import HeroSection from "../components/heroSection";
import InfoSection from "../components/infoSection";
import { Navbar } from "./../components/navbar";
import { Sidebar } from "./../components/sidebar";

import Image1 from "../images/design-notes.svg";
import Image2 from "../images/space.svg";
import InfoSectionLight from "../components/infoSectionLight";
import Services from "../components/services";
import Footer from "../components/footer";
import ContactForm from "../components/contact";
import Team from "../components/team";

export const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection />
      <InfoSection
        image={Image1}
        id="about"
        title="About"
        text="Empowered with rich technical expertise, AlphaC is embarked as one of the leading Software development companies in India for over two decades now. Surpassing client’s expectations with qualitative and timely deliverables, our development team has transformed businesses by building apps that are competent, agile and high-performant. Our technical prowess and domain proficiency allow businesses to meet custom business needs with the capability of our diversified and resourceful professionals."
      />
      <InfoSectionLight
        image={Image2}
        id="discover"
        subtitle="Mission"
        title="About Company"
        text="Our mission is to provide innovative software solutions for excellence and enterprise compliance."
        subtitle2="Vision"

        text2="Our vision is to become businesses' first choice when it comes to software development and maintenance. To accomplish this, we always try to exceed our client's expectations. AlphaC strives to build lasting partnerships and ensures client satisfaction."
      />
      <Services />
      <Team id="ourteam" />

      <Footer />
    </>
  );
};
